import {QUERY_KEYS} from '@/queryClient'
import {useQuery} from '@tanstack/react-query'
import {httpGetRankingList} from '../services/rank.http'

export const useGetRankingList = () =>
    useQuery({
        queryKey: [QUERY_KEYS.RANKING_LIST],
        queryFn: () => httpGetRankingList()
    })
